import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    confirmed: {
      color: theme.palette.success.main,
      fontSize: theme.typography.pxToRem(11),
    },

    unconfirmed: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(11),
    },

    updateButton: {
      textTransform: 'inherit',
      textAlign: 'right',
      padding: 0,
    },

    capitalize: {
      textTransform: 'capitalize',
    },

    textRight: {
      textAlign: 'right',
    },

    gridContainer: {
      borderBottom: `1px solid ${theme.palette.common.greyLight}`,
      paddingBottom: 14,
      marginBottom: 14,
    },

    userGroupLink: {
      fontSize: '12px',
      fontWeight: 500,
      textDecoration: 'none',
      textTransform: 'capitalize',
      '&:hover': {
        textDecoration: 'none',
        fontWeight: 500,
      },
    },

    collapsiblePanel: {
      boxShadow: 'none',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderBottom: 'none',
      margin: '16px 0px',

      '&.Mui-expanded': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      },
    },

    collapsibleHeaderBorder: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      padding: '24px 32px',
    },

    userList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    userListItem: {
      width: '100%',
      padding: '0 4px 8px 0',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.common.greyLight}`,
      },
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    primary: {
      fontSize: '13px',
      fontWeight: 'bold',
      color: '#4D4F5C',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

const collapseCardStyles = makeStyles({
  root: {
    marginTop: 20,
    marginBottom: 20,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});

export { useStyles, listTextStyles, customCardStyles, collapseCardStyles };
